import { StepProps, StepsProps } from "antd";
import classnames from "classnames";

import FontFa from "../fontFa/fontFa";
import styles from "./Steps.module.scss";

interface StepContent {
  name: string;
  email: string;
  actionText?: string;
  date?: string;
}
export interface Step extends StepProps {
  stepContent?: StepContent;
}

export type StepItem = Step | Step[];
interface Props extends Omit<StepsProps, "items"> {
  items: StepItem[];
}

function StepDescription({ name, email, actionText, date }: StepContent) {
  return (
    <div className={styles.stepDescription}>
      <div>{name}</div>
      <div>{email}</div>
      {date && (
        <div className={styles.stepDescriptionDate}>
          {actionText}
          {date}
        </div>
      )}
    </div>
  );
}

function StepContentCom({ title, description, stepContent }: any) {
  return (
    <div className={styles.stepContent}>
      {title && <div className={styles.title}>{title}</div>}
      {description && <div className="content">{description}</div>}
      {stepContent && <StepDescription {...stepContent} />}
    </div>
  );
}

export function Steps(props: Partial<Props>) {
  const {
    direction = "horizontal",
    size = "default",
    current = 0,
    items = [],
    status = "",
  } = props;

  const classNames = classnames("TimelineBox horizontal", {
    mdHorizontal: direction === "horizontal",
    mdSmall: size === "small",
  });

  const getStep = (currentIndex: number) => {
    const isApproved =
      currentIndex < current ||
      (status === "finish" && currentIndex === current);
    const isRejected = status === "error" && currentIndex === current;
    if (isApproved) {
      return { icon: <FontFa name="faCheck" />, classNameStatus: "approved" };
    }
    if (isRejected) {
      return { icon: <FontFa name="faBan" />, classNameStatus: "rejected" };
    }
    return { icon: null, classNameStatus: "waiting" };
  };

  return (
    <div className={classNames}>
      {items.map((item, idx) => {
        return (
          <div key={idx} className={classnames("item", styles.item)}>
            <div className={classnames("step", getStep(idx).classNameStatus)}>
              {getStep(idx).icon}
            </div>
            <div className={classnames("content", styles.content)}>
              {Array.isArray(item) ? (
                item.map((step) => (
                  <StepContentCom key={step.title} {...step} />
                ))
              ) : (
                <StepContentCom {...item} />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
